import request from '@/utils/request'
import api from '../api'

export class OverseasC {
  receiptAll(data) {
    return request({
      url: api.overseasCollection.receiptAll,
      method: 'post',
      data
    })
  }
  setCreate(data) {
    return request({
      url: api.overseasCollection.setCreate,
      method: 'post',
      data
    })
  }


}